import { Component, OnInit } from '@angular/core';
import { ToursService } from 'src/app/_services/tours.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { NgbCarouselConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl, AbstractControl, ValidatorFn } from '@angular/forms';
import { ModalReservaComponent } from '../modal-reserva/modal-reserva.component';
import { Subject, Observable } from 'rxjs';
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-tour-passengers',
  templateUrl: './tour-passengers.component.html',
  styleUrls: ['./tour-passengers.component.css']
})
export class TourPassengersComponent implements OnInit {
  form: FormGroup;
  imagenes: any[]=[];
  tourId;
  tourDetail;
  lastDNISearch;
  newReservation;
  submitted = false;
  passangers: any[]=[];
  passangersList = new FormArray([]);
  bloquear: boolean = false;
  habitaciones: any[]=[];
  asientos:any[] = [];
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  constructor(
    private tourService: ToursService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    config: NgbCarouselConfig,
    private formBuilder: FormBuilder,
    private fb: FormBuilder) {
    const id: string = this.activeRoute.snapshot.paramMap.get('tourid');

		if (Number(id) > 0) {
			this.tourId = Number(id);
    }

    config.showNavigationArrows = false;
    config.showNavigationIndicators = true;
    config.interval = 10000;
    config.animation = true;
     this.newReservation= JSON.parse(localStorage.getItem("reservation"));

     if(!this.newReservation){
      this.router.navigate(['/','tours', 'reservation' ,this.tourId]);
     }
   }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      pasajeros: this.formBuilder.array([], Validators.required),
    });
    //obtener habitaciones del paquete
    var value;
    if(this.newReservation.individual !== 0){
      value=1;
      this.habitaciones.push({id: 1, tipo: 'Individual'});
    }
    if(this.newReservation.doble !== 0) {
      value=2;
      this.habitaciones.push({id: 2, tipo: 'Doble'});
    }
    if(this.newReservation.triple !== 0){
      value=3
      this.habitaciones.push({id: 3, tipo: 'Triple'});
    }
    if(this.newReservation.cuadruple !== 0) {
      value=4;
      this.habitaciones.push({id: 4, tipo: 'Cuadruple'});
    }
    if(this.newReservation.id !== 0){
      this.bloquear = true;
      this.tourService.getPasajeros(this.newReservation.id).subscribe(list=>{
        for (let index = 0; index < list.length; index++) {
          this.pasajeros.push(this.createPasajero(list[index]));
        }
      });
    } else {
      this.bloquear =  false;
      var numeroPasajeros =  this.newReservation.adultos + this.newReservation.menores;
      for (let index = 0; index < numeroPasajeros; index++) {
        this.pasajeros.push(this.anadirPasajero(value, false));
      }
      //para pasajeros bebe
      for (let index = 0; index < this.newReservation.bebes; index++) {
        this.pasajeros.push(this.anadirPasajero(value, true));
      }
    }
    var asientosString:string = this.newReservation.asientos;
     asientosString.split('*').forEach(value=>{
      this.asientos.push({
        disabled: false,
        name: value
      })
    });
    this.loadImagen(this.tourId,0);
    this.loadTourDetail(this.tourId);
  }
  get pasajeros(): FormArray {
    return this.form.get('pasajeros') as FormArray;
  };
  anadirPasajero(value, bebe): FormGroup {
    var email_patter = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var bb = bebe?1:0;
    return this.formBuilder.group({
      nombre: new FormControl({value:'', disabled: this.bloquear}, Validators.required),
      telefono: new FormControl({value:'', disabled: this.bloquear}, Validators.required),
      email: new FormControl({value:'', disabled: this.bloquear}, [Validators.required,Validators.pattern(email_patter)]),
      tipoDocumento: new FormControl({value:'', disabled: this.bloquear}, Validators.required),
      numeroDocumento: new FormControl({value:'', disabled: this.bloquear}, Validators.required),
      observaciones: new FormControl({value:'', disabled: this.bloquear}),
      habitacion: new FormControl({value: value, disabled: this.bloquear}, Validators.required),
      bebe: new FormControl({value: bb, disabled: this.bloquear}, Validators.required),
      asiento: bb == 1 ? new FormControl({value:'', disabled: this.bloquear}) : new FormControl({value:'', disabled: this.bloquear}, Validators.required)
    },{
        validators: [this.dniValidator()]
    });
  }


  createPasajero(data): FormGroup {
    var bb = data.bebe?1:0;
    return this.formBuilder.group({
      nombre: new FormControl({value: data.nombre_pasajero, disabled: true}),
      telefono: new FormControl({value: data.telefono_pasajero, disabled: true}),
      email: new FormControl({value: data.email_pasajero, disabled: true}),
      tipoDocumento: new FormControl({value: data.tipo_documento, disabled: true}),
      numeroDocumento: new FormControl({value: data.numero_documento, disabled: true}),
      observaciones: new FormControl({value: data.observaciones_pasajero, disabled: true}),
      habitacion: new FormControl({value: data.id_tipoHabitacion, disabled: true}),
      bebe: new FormControl({value: bb, disabled: this.bloquear}),
      asiento: bb == 1 ? new FormControl({value:'', disabled: this.bloquear}) : new FormControl({value:'', disabled: this.bloquear}, Validators.required)
    });
  }


  loadImagen(idtour,imagenType){
    this.tourService.getImageByType(idtour,imagenType).subscribe(img=>{
      this.imagenes = img;
    });
  }
  loadTourDetail(idtour){
    this.tourService.getTourDetail(idtour).subscribe(tour=>{
      this.tourDetail = tour;
    });
  }

  submit(){
    if(this.bloquear){
      this.submitted=false;
        const modalRef = this.modalService.open(ModalReservaComponent, {
          centered: true,
          backdrop:'static'
        });
        modalRef.componentInstance.id_reservacion = this.newReservation.id;
        modalRef.componentInstance.id_paquete = this.tourId;

    }
    else {
      this.submitted=true;

      // stop here if form is invalid
      if (this.form.invalid) {
        console.log('Pasajeros: '+JSON.stringify(this.form.value.pasajeros));
        console.log('Formulario nvalido');
        return;
      }
      this.passangers = this.form.value.pasajeros;

      this.tourService.postReservation(this.newReservation).subscribe(res=>{

        let passangersToPersist={
          id_reservacion:res.obj.id,
          pasajeros: this.passangers
        }
        this.newReservation.id = res.obj.id;
        localStorage.setItem('reservation', JSON.stringify(this.newReservation));

        this.tourService.postPassenger(passangersToPersist).subscribe(pass=>{
          this.submitted=false;

          const modalRef = this.modalService.open(ModalReservaComponent, {
            centered: true,
            backdrop:'static'
          });
          modalRef.componentInstance.id_reservacion = res.obj.id;
          modalRef.componentInstance.id_paquete = this.tourId;
          this.redirectTo(this.router.url);
        })
      })
    }
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }

  keypressNumber(event){
    var k;
    k = event.charCode;
    return ((k >= 48 && k <= 57));
  }

  dniValidator(): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get("numeroDocumento");
      if (this.lastDNISearch == control.value) {
        return null;
      } else {
        this.lastDNISearch = control.value;
      }
      // console.log(control.value);
      this.tourService.getPasajeroByDni(control.value)
      .pipe( takeUntil(this._unsubscribeAll) )
      .subscribe(pasajero=>{
        // console.log(pasajero);
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        if(pasajero.nombre_pasajero){
          controls.get("nombre").setValue(pasajero.nombre_pasajero);
        };
        if(pasajero.telefono_pasajero){
          controls.get("telefono").setValue(pasajero.telefono_pasajero);
        };
        if(pasajero.email_pasajero){
          controls.get("email").setValue(pasajero.email_pasajero);
        };
        if(pasajero.tipo_documento){
          controls.get("tipoDocumento").setValue(pasajero.tipo_documento);
        };
        if(pasajero.observaciones_pasajero){
          controls.get("observaciones").setValue(pasajero.observaciones_pasajero);
        };
        if(pasajero.bebe){
          controls.get("bebe").setValue(pasajero.bebe);
        };
      });

      return null;
    };
  }

  onChange(deviceValue) {
    this.asientos = this.asientos.map((d)=>{
      if(d.name == deviceValue){
        return {
          disabled: true,
          name: d.name
        }
      }else{
        return {
          disabled: false,
          name: d.name
        }
      }
    });

  }
}
